import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";
//import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { HeaderComponent } from './layout/header/header.component';
import {Layout1Component} from "./layout/layouts/layout-1/layout.component";
import {Layout2Component} from "./layout/layouts/layout-2/layout.component";
import { AuthResolver } from './resolver/auth.resolver';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { SignResolver } from './services/signresolver.service';

// const routes: Routes = [
// { path: '', component: LoginComponent},
// { path: 'dashboard', component: DashboardComponent,canActivate: [AuthGuard] },
// { path: 'header', component: HeaderComponent,canActivate: [AuthGuard] },
// { path: 'free-flow-upload', component: FreeFlowUploadComponent},
// { path: 'sign-doc', component: SignDocComponent},
//  //otherwise redirect to home
// { path: '**', redirectTo: 'LoginComponent' }
// ];
const routes: Routes = [
    // { path: '', component: LoginComponent},
    // { path: 'dashboard', component: DashboardComponent,canActivate: [AuthGuard] },
    // { path: 'header', component: HeaderComponent,canActivate: [AuthGuard] },
    // { path: 'free-flow-upload', component: FreeFlowUploadComponent},
    // { path: 'sign-doc', component: SignDocComponent},
    // //otherwise redirect to home
    // { path: '**', redirectTo: 'LoginComponent' },
    {
        path: "",
        component: Layout1Component,
        children: [
            //Request Listing
            {
                path: "overview",
                loadChildren: () => import('./pages/request-listing/request-listing.module').then(m => m.RequestListingModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2,3,4,5,6,7,8]
                }
            },
            // Deal Listing
            {
              path: "deal-listing",
              loadChildren: () => import('./pages/deal-listing/deal-listing.module').then(m => m.DealListingModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4,5,6,7]
              }
            },
            // Invoice Listing
            {
              path: "invoice-listing",
              loadChildren: () => import('./pages/invoice-listing/invoice-listing.module').then(m => m.invoiceListingModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4]
              }
            },
            //Group Doc Listing
            {
              path: "upload-listing",
              loadChildren: () => import('./pages/upload-listing/upload-listing.module').then(m => m.UploadListingModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [1,2,3,4,5,6,7,8]
              }
           },
              //Group Doc Listing
              {
                path: "upload-listing/:doc_id",
                loadChildren: () => import('./pages/upload-listing/upload-listing.module').then(m => m.UploadListingModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2,3,4,5,6,7,8]
                }
            },
            {
              path: "invoice-listing/:pagenumber",
              loadChildren: () => import('./pages/invoice-listing/invoice-listing.module').then(m => m.invoiceListingModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4]
              }
            },
           
            //Settings
            {
                path: "settings",
                loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2,3,4,5,6,7,8]
                }
            },
            {
              path: "company-doc-group",
              loadChildren: () => import('./pages/company-doc-groups/company-doc-groups.module').then(m => m.companyDocGroupsModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [1,2,3,4]
              }
            },
            {
                path: "feature",
                loadChildren: () => import('./pages/feature/feature.module').then(m => m.FeatureModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2,3,4,5,6,7,8]
                }
            },
            // Home
            {
                path: "",
                redirectTo: "login",
                pathMatch: "full"
            },
            //team
            {
                path: "user_team",
                loadChildren: () => import('./pages/company-team/team.module').then(m => m.TeamModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [4,5]
                }
            },
            //create user
            {
                path: "add-user",
                loadChildren: () => import('./pages/add-user/add-user.module').then(m => m.AddUserModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2,4,5]
                }

            },
            //create company
            {
                path: "add-company",
                loadChildren: () => import('./pages/add-company/add-company.module').then(m => m.AddCompanyModule),
                canActivate: [AuthGuard],
                resolve: {
                  data: SignResolver
                },
                data: {
                  expectedRole: [1,2]
                }

            },
            //manage company
            {
                path: "manage-company",
                loadChildren: () => import('./pages/manage-company/manage-company.module').then(m => m.ManageCompanyModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1,2,3]
                }

            },
            //edit user
            {
                path: "edit-company",
                loadChildren: () => import('./pages/add-company/add-company.module').then(m => m.AddCompanyModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2]
                }

            },
            //edit user
            {
                path: "edit-user",
                loadChildren: () => import('./pages/add-user/add-user.module').then(m => m.AddUserModule),
                canActivate: [AuthGuard],
                resolve: {
                  data: SignResolver
                },
                data: {
                  expectedRole: [1,2,3,4,5,6,7,8]
                }
            },
            //manage user
            {
                path: "manage-user",
                loadChildren: () => import('./pages/manage-user/manage-user.module').then(m => m.ManageUserModule),
                canActivate: [AuthGuard],
                resolve: {
                  data: SignResolver
                },
                data: {
                    expectedRole: [1,2,3,4,5,6,7]
                }

            },
            //template
            {
                path: "template",
                loadChildren: () => import('./pages/template/template.module').then(m => m.TemplateModule),
                canActivate: [AuthGuard],
                resolve: {
                  data: SignResolver
                },
                data: {
                    expectedRole: [1,2,3,4,5,6]
                }

            },
            //create template
            {
                path: "create-template",
                loadChildren: () => import('./pages/send-request/send-request.module').then(m => m.SendRequestModule)
            },

            {
              path: "edit-template-settings",
              loadChildren: () => import('./pages/template-settings/template-settings.module').then(m => m.TemplateSettingsModule),
              canActivate: [AuthGuard],
              resolve: {
                data: SignResolver
              },
              data: {
                expectedRole: [1,2,3,4,5,6]
              }

            },

            //sign-doc-free-flow
            {
                path: "sign-free-flow",
                loadChildren: () => import('./pages/sign-doc-free-flow/sign-doc-free-flow.module').then(m => m.SignDocFreeFlowModule),
                resolve: {
                  data: SignResolver
                }
            },
            //prepareTemplate
            {
                path: "sign-doc",
                loadChildren: () => import('./pages/sign-doc/sign-doc.module').then(m => m.SignDocModule),
                resolve: {
                  data: SignResolver
                }
            },
            {
              path: "sign-doc-new",
              loadChildren: () => import('./pages/sign-doc-new/sign-doc-new.module').then(m => m.SignDocNewModule),
              resolve: {
                data: SignResolver
              }
            },
            //free-flow
            {
                path: "free-sign",
                loadChildren: () => import('./pages/free-flow/free-flow.module').then(m => m.FreeFlowModule)
            },
            //free-flow
            {
              path: "freesign",
              loadChildren: () => import('./pages/free-sign/free-sign.module').then(m => m.FreeSignModule)
            },
            //quick-flow
            {
                path: "quick-sign",
                loadChildren: () => import('./pages/quick-flow/quick-flow.module').then(m => m.QuickFlowModule),
                resolve: {
                  data: SignResolver
                }
            },
            //kit
            {
                path: "kit",
                loadChildren: () => import('./pages/doc-kit/doc-kit.module').then(m => m.DocKitModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [4,5,6,7]
                }
            },
	//Role Assign
            {
                path: "assign-role",
                loadChildren: () => import('./pages/assign-role/assign-role.module').then(m => m.AssignRoleModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1]
                }
            },
            //Signatutre
            {
                path: "signature/:randomstring/:signtoken",
                loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
                //resolve: { message: false }
            },
            {
              path: "signature/:signtoken",
              loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
              //resolve: { message: false }
            },
            {
                path: "sign/:randomstring/:signtoken",
                loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
                //resolve: { message: false }
            },
            {
              path: "sign/:signtoken",
              loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
              //resolve: { message: false }
            },
            {
              path: "verifyach/:randomstring",
              loadChildren: () => import('./pages/verifyach/verifyach.module').then(m => m.VerifyachModule),
              //resolve: { message: false }
            },
            {
              path: "pay/:randomstring/:signtoken",
              loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
              //resolve: { message: false }
            },
            {
              path: "pay/:signtoken",
              loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
              //resolve: { message: false }
            },
            {
              path: "prefill-request/:signtoken",
              loadChildren: () => import('./pages/doc-form/doc-form.module').then(m => m.DocFormModule),
              //resolve: { message: false }
            },
            {
                path: "doc-comments/:randomstring/:signtoken",
                loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
                //resolve: { message: false }
            },
            {
                path: "doc-comments/:signtoken",
                loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
                //resolve: { message: false }
            },
            {
                path: "viewdoc/:signtoken",
                loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
                //resolve: { message: false }
            },
            //Signatutre
            {
                path: "signature/:randomstring/:signtoken/:assign",
                loadChildren: () => import('./pages/sign/sign.module').then(m => m.SignModule),
                //resolve: { message: false }
            },
            //Signatutre
            {
                path: "edit-document/:randomstring/:signtoken",
                loadChildren: () => import('./pages/sign-doc/sign-doc.module').then(m => m.SignDocModule),
                resolve: {
                  data: SignResolver
                }
                //resolve: { message: false }
            },
            {
                path: "email-template",
                loadChildren: () => import('./pages/email-template/email-template.module').then(m => m.EmailTemplateModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1,2,3,4,5]
                }
            },
            {
              path: "company-plan",
              loadChildren: () => import('./pages/company-plan/company-plan.module').then(m => m.CompanyPlanModule),
              canActivate: [AuthGuard],
              data: {
                  expectedRole: [1]
              }
            },
            {
                path: "coupons",
                loadChildren: () => import('./pages/coupons/coupons.module').then(m => m.CouponsModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1,4]
                }
              },
            {
                path: "subscription-list",
                loadChildren: () => import('./pages/subscription-list/subscription-list.module').then(m => m.SubscriptionListModule),
                canActivate: [AuthGuard],
                resolve: {
                  data: SignResolver
                },
                data: {
                    expectedRole: [1]
                }
              },
              {
                path: "manage-product",
                loadChildren: () => import('./pages/company-basic-plan/company-basic-plan.module').then(m => m.CompanyBasicPlanModule),
                canActivate: [AuthGuard],
                data:{
                  expectedRole: [1,4]
                }
              },
              {
                path: "manage-license",
                loadChildren: () => import('./pages/license/license.module').then(m => m.licenseModule),
                canActivate: [AuthGuard],
                data:{
                  expectedRole: [1]
                }
              },
              /* {
                  path: "cdk-drag-drop",
                  loadChildren: "./pages/ang-drag-drop/ang-drag-drop.module#AngDragDropModule"
              },*/
              {
                  path: "send-request",
                  loadChildren: () => import('./pages/send-request/send-request.module').then(m => m.SendRequestModule),
                  canActivate: [AuthGuard],
                  resolve: {
                    data: SignResolver
                  },
                  data: {
                    expectedRole: [4,5,6,7,8]
                  }
              },
              {
                path: "share-template",
                loadChildren: () => import('./pages/send-request/send-request.module').then(m => m.SendRequestModule),
                canActivate: [AuthGuard],
                resolve: {
                  data: SignResolver
                },
                data: {
                  expectedRole: [4,5,6,7,8]
                }
              },
              {
                path: "send-watermark-doc",
                loadChildren: () => import('./pages/watermark-template/watermark-template.module').then(m => m.WatermarkTemplateModule),
                // canActivate: [AuthGuard],
                // resolve: {
                //   data: SignResolver
                // },
                // data: {
                //   expectedRole: [4,5,6,7]
                // }
              },
              {
                path: "send-watermark-doc/:hash",
                loadChildren: () => import('./pages/watermark-template/watermark-template.module').then(m => m.WatermarkTemplateModule),
                // canActivate: [AuthGuard],
                // resolve: {
                //   data: SignResolver
                // },
                // data: {
                //   expectedRole: [4,5,6,7]
                // }
              },
              {
                  path: "upload-doc/:hash",
                  loadChildren: () => import('./pages/upload-doc/upload-doc.module').then(m => m.UploadDocModule)
              },
              {
                  path: "hubspot-integration-new",
                  loadChildren: () => import('./pages/hubspot/hubspot.module').then(m => m.HubspotModule),
                  canActivate: [AuthGuard],
                  data: {
                    expectedRole: [4,5]
                  }
              },
            {
              path: "hubspot-integration",
              loadChildren: () => import('./pages/hubspotnew/hubspotnew.module').then(m => m.HubspotnewModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4,5]
              }
            },{
              path: "dealhub-config",
              loadChildren: () => import('./pages/dealhub-config/dealhub-config.module').then(m => m.DealhubConfigModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4]
              }
            },
            {
              path: "younium-tool",
              loadChildren: () => import('./pages/younium-tool/younium-tool.module').then(m => m.YouniumToolModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4,5]
              }
            },
            {
                path: "hubspot-success",
                loadChildren: () => import('./pages/hubspot/hubspot.module').then(m => m.HubspotModule),
                /*canActivate: [AuthGuard],
                data: {
                    expectedRole: [4,5,6,7]
                }*/
            },
            {
              path: "google-drive-success",
              loadChildren: () => import('./pages/google-drive/google-drive.module').then(m => m.GoogleDriveModule),
              /*canActivate: [AuthGuard],
              data: {
                  expectedRole: [4,5,6,7]
              }*/
            },
            {
              path: "gmail-connection-success",
              loadChildren: () => import('./pages/gmail-connection/gmail-connection.module').then(m => m.GmailConnectionModule),
              /*canActivate: [AuthGuard],
              data: {
                  expectedRole: [4,5,6,7]
              }*/
            },
            {
                path: "manage-keys",
                loadChildren: () => import('./pages/manage-key/manage-key.module').then(m => m.ManageKeyModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [4,5]
                }
            },
            {
              path: "manage-subscriptions",
              loadChildren: () => import('./pages/manage-subscriptions/manage-subscriptions.module').then(m => m.ManageSubscriptionsModule),
              canActivate: [AuthGuard],
              resolve: {
                data: SignResolver
              },
              data: {
                  expectedRole: [4,5]
              }
            },
            {
              path: "manage-cards",
              loadChildren: () => import('./pages/manage-cards/manage-cards.module').then(m => m.ManageCardsModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4,5,6]
              }
          },
            {
              path: "manage-bank-accounts",
              loadChildren: () => import('./pages/manage-bank-accounts/manage-bank-accounts.module').then(m => m.ManageBankAccountsModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [4,5,6]
              }
            },
            {
              path: "plans",
              loadChildren: () => import('./pages/plans/plans.module').then(m => m.PlansModule),
              canActivate: [AuthGuard],
              resolve: {
                data: SignResolver
              },
              data: {
                expectedRole: [4,5,6,8]
              }
            },
            {
              path: "google-drive",
              loadChildren: () => import('./pages/google-drive/google-drive.module').then(m => m.GoogleDriveModule),
              canActivate: [AuthGuard],
              data: {
                expectedRole: [1,2,3,4,5,6,7]
              }
          },
          {
            path: "dropbox",
            loadChildren: () => import('./pages/dropbox/dropbox.module').then(m => m.DropboxModule),
            canActivate: [AuthGuard],
            data: {
              expectedRole: [1,2,3,4,5,6,7]
            }
          },
            {
                path: "business-doc-signee",
                loadChildren: () => import('./pages/business-doc-signee/business-doc-signee.module').then(m => m.BusinessDocSigneeModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [4,5]
                }
            },
            {
                path: "groups",
                loadChildren: () => import('./pages/groups/groups.module').then(m => m.GroupsModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [4,5]
                }
            },

            /*{
                path: "buy-plan",
                loadChildren: "./pages/buy-plan/buy-plan.module#BuyPlanModule",
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [4,5]
                }
            },
            {
                path: "manage-company-plan",
                loadChildren: "./pages/manage-company-plan/manage-company-plan.module#ManageCompanyPlanModule",
                canActivate: [AuthGuard],
                data:{
                  expectedRole: [1,2,3]
                }
            },
            {
                path: "create-plan",
                loadChildren: "./pages/create-plan/create-plan.module#CreatePlanModule",
                canActivate: [AuthGuard],
                data:{
                  expectedRole: [1,2,3]
                }
            },*/
            {
                path: "change-password",
                loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordModule),
                canActivate: [AuthGuard],
                data:{
                  expectedRole: [1,2,3,4,5,6,7,8]
                }
            },
            {
                path: "company-access-limit",
                loadChildren: () => import('./pages/company-access-limit/company-access-limit.module').then(m => m.CompanyAccessLimitModule),
                canActivate: [AuthGuard],
                data:{
                  expectedRole: [1,2,3]
                }
            },
            {
                path: "company-call-log",
                loadChildren: () => import('./pages/company-call-log/company-call-log.module').then(m => m.CompanyCallLogModule),
                canActivate: [AuthGuard],
                resolve: {
                  data: SignResolver
                },
                data:{
                  expectedRole: [1,2,3]
                }
            },
            {
                path: "invite-company",
                loadChildren: () => import('./pages/invite-company/invite-company.module').then(m => m.InviteCompanyModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2]
                }
            },
            {
                path: "queue-monitoring",
                loadChildren: () => import('./pages/queue-monitoring/queue-monitoring.module').then(m => m.QueueMonitoringModule),
                canActivate: [AuthGuard],
                data: {
                  expectedRole: [1,2,3]
                }
            },
            {
                path: "default-gateway",
                loadChildren: () => import('./pages/default-gateway/default-gateway.module').then(m => m.DefaultGatewayModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1]
                }
            },
            {
                path: "client-session",
                loadChildren: () => import('./pages/client-session/client-session.module').then(m => m.ClientSessionModule),
                canActivate: [AuthGuard],
                data:{
                  expectedRole: [1,2]
                }
            },
            {
              path: "postmapping-logs",
              loadChildren: () => import('./pages/postmapping-logs/postmapping-logs.module').then(m => m.PostmappingLogsModule),
              canActivate: [AuthGuard],
              data: {
                  expectedRole: [1,2,3,4,5,6,7]
              }
            },
            {
                path: "activity-log",
                loadChildren: () => import('./pages/activity-log/activity-log.module').then(m => m.ActivityLogModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1,2,3,4,5,6,7]
                }
            },
            {
                path: "storage-log",
                loadChildren: () => import('./pages/storage-logs/storage-logs.module').then(m => m.StorageLogsModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1,2,3,4,5,6,7]
                }
            },
            {
                path: "request-log",
                loadChildren: () => import('./pages/request-log/request-log.module').then(m => m.RequestLogModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [1,2,3,4,5,6,7]
                }
            },
            {
              path: "request-input-logs",
              loadChildren: () => import('./pages/request-input-logs/request-input-logs.module').then(m => m.RequestInputLogsModule),
              canActivate: [AuthGuard],
              data: {
                  expectedRole: [1,2,3,4,5,6,7]
              }
          },
            {
                path: "storage-cloud",
                loadChildren: () => import('./pages/storage-cloud/storage-cloud.module').then(m => m.StorageCloudModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [4,5]
                }
            },
            {
                path: "google-spreadsheet",
                loadChildren: () => import('./pages/google-spreadsheet/google-spreadsheet.module').then(m => m.GoogleSpreadsheetModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [4,5]
                }

            },
            {
              path: "slack",
              loadChildren: () => import('./pages/slack/slack.module').then(m => m.SlackModule),
              canActivate: [AuthGuard],
              data:{
                expectedRole: [1,2,3,4,5,6]
              }
          },{
            path: "tmdAI",
            loadChildren: () => import('./pages/slack/slack.module').then(m => m.SlackModule),
            canActivate: [AuthGuard],
            data:{
              expectedRole: [1,2,3,4,5,6]
            }
        },
            //transfer-ownership
            {
                path: "transfer-ownership",
                loadChildren: () => import('./pages/transfer-ownership/transfer-ownership.module').then(m => m.TransferOwnershipModule),
                canActivate: [AuthGuard],
                data: {
                    expectedRole: [4,5,6,7]
                }
            },
            //transger-ownership-confirmation
            {
                path: "ownership-transfer-conf/:hash",
                loadChildren: () => import('./pages/transfer-ownership-conf/transfer-ownership-conf.module').then(m => m.TransferOwnershipConfModule)
            },

            //Notifications
            {
              path: "notifications",
              loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsModule),
              canActivate: [AuthGuard],
              data: {
                  expectedRole: [1,2,3,4,5,6,7,8]
              }
            },

			      {
                path: "download/:randomstring/:status",
                loadChildren: () => import('./pages/download/download.module').then(m => m.DownloadModule)
            },
			      {
                path: "download/:randomstring/:status",
                loadChildren: () => import('./pages/download/download.module').then(m => m.DownloadModule)
            },
            {
                path: "download/:randomstring",
                loadChildren: () => import('./pages/download/download.module').then(m => m.DownloadModule)
            },
            {
                path: "approve-hubspot-properties-updation/:hashtype/:randomstring",
                loadChildren: () => import('./pages/approve-hubspot-properties-updation/approve-hubspot-properties-updation.module').then(m => m.ApproveHubspotPropertiesUpdationModule),
            },
	        {
              path: "terms-conditions",
              loadChildren: () => import('./pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule)
            },


        ],
        resolve: { message: AuthResolver }
    },
    {
        path: "",
        component: Layout2Component,
        children: [
            {
                path: "login",
                loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
            },{
                path: "login/:test_auto",
                loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
            },{
              path: "slacklogin/:usertoken",
              loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
            },{
              path: "slackerror/:slack_error",
              loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
            },{
              path: "dealhubsession/:session_expire",
              loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
            },
            {
                path: "reset-password/:randomstring",
                loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
            },
            {
              path: "reset-password/:randomstring/:type",
              loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
          },
            {
              path: "supportunblock/:randomstring",
              loadChildren: () => import('./pages/support-unblock/support-unblock.module').then(m => m.SupportUnblockModule)
            },
            {
                path: "approve-and-send/:randomstring",
                loadChildren: () => import('./pages/approve-send/approve-send.module').then(m => m.ApproveSendModule)
              },
            {
                path: "secondary-email-verify/:randomstring",
                loadChildren: () => import('./pages/secondary-email-verify/secondary-email-verify.module').then(m => m.SecondaryEmailVerifyModule)
            },
            {
                path: "verify-user/:randomstring",
                loadChildren: () => import('./pages/verify-registration/verify-registration.module').then(m => m.VerifyRegistrationModule)
            },
            {
              path: "useremail-verify/:randomstring",
              loadChildren: () => import('./pages/verify-useremail/verify-useremail.module').then(m => m.VerifyUseremailModule)
            },
            {
              path: "useremail-verify/:randomstring/:type",
              loadChildren: () => import('./pages/verify-useremail/verify-useremail.module').then(m => m.VerifyUseremailModule)
            },
            {
                path: "user-account-verify/:randomstring",
                loadChildren: () => import('./pages/user-account-verify/user-account-verify.module').then(m => m.UserAccountVerifyModule)
            },
            {
              path: "approve-hubspot-updation/:hashtype/:randomstring/:signtoken",
              loadChildren: () => import('./pages/approve-hubspot-updation/approve-hubspot-updation.module').then(m => m.ApproveHubspotUpdationModule),
              //resolve: { message: false }
            },
            {
              path: "approvedoc/:signtoken",
              loadChildren: () => import('./pages/approve-watermark-documents/approve-watermark-documents.module').then(m => m.ApproveWaterMarkDocumentsModule),
              //resolve: { message: false }
            },
            {
              path: "reactivate-request/:signtoken",
              loadChildren: () => import('./pages/reactivate-request/reactivate-request.module').then(m => m.ReactivateRequestModule),
              //resolve: { message: false }
            },
	          {
                path: "company-register/:randomstring",
                loadChildren: () => import('./pages/company-register/company-register.module').then(m => m.CompanyRegisterModule)
            },
            {
              path: "company-register/:randomstring/:slackdomain/:slackname",
              loadChildren: () => import('./pages/company-register/company-register.module').then(m => m.CompanyRegisterModule)
            },
            {
                path: "company-register",
                loadChildren: () => import('./pages/company-register/company-register.module').then(m => m.CompanyRegisterModule)
            },
            {
                path: "change-regular-password/:password_token/:regular",
                loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
            },
            {
                path: "quote",
                loadChildren: () => import('./pages/hubspot-quote/hubspot-quote.module').then(m => m.HubspotQuoteModule)
            },
            {
                path: "preview-document/:randomstring/:signtoken/:hubspot",
                loadChildren: () => import('./pages/sign-doc/sign-doc.module').then(m => m.SignDocModule),
                resolve: {
                  data: SignResolver
                }
                //resolve: { message: false }
            },
            {
              path: "storage/:randomstring",
              loadChildren: () => import('./pages/storage/storage.module').then(m => m.StorageModule)
            },
            {
              path: "dealhub",
              loadChildren: () => import('./pages/deal-hub/deal-hub.module').then(m => m.dealHubModule)
            },
	    {
              path: "upload-document",
              loadChildren: () => import('./pages/upload-doc-slot/upload-doc-slot.module').then(m => m.uploadDocSlotModule)
            },
            {
              path: "upload-document/:randomstring",
              loadChildren: () => import('./pages/upload-docs/upload-docs.module').then(m => m.UploadDocsModule)
            },
            {
              path: "dealhub/:randomstring",
              loadChildren: () => import('./pages/deal-hub/deal-hub.module').then(m => m.dealHubModule)
            },
            {
              path: "similar-deals/:randomstring",
              loadChildren: () => import('./pages/similar-deals/similar-deals.module').then(m => m.SimilarDealsModule)
            },
            {
                path: "**",
                redirectTo: "/404"
            }
        ]
    }
];

// @NgModule({
//     imports: [RouterModule.forRoot(routes, {useHash: true})],
//     exports: [RouterModule]
// })
// export class AppRoutingModule {
// }
@NgModule({
  //imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule],
  providers: [
    AuthResolver
  ]
})
export class AppRoutingModule { }
